import { useMutation } from '@apollo/client';
import { DELETE_STAGE } from '../queries/DeleteStageMutation';

export function useDeleteStage() {
  const [deleteStage, { loading, error }] = useMutation(DELETE_STAGE);

  const handleDeleteStage = async (programId: number, stageName: string) => {
    try {
      await deleteStage({
        variables: {
          data: {
            programId,
            stageName,
          },
        },
      });
      return true;
    } catch (err) {
      console.error('Error deleting stage:', err);
      return false;
    }
  };

  return {
    handleDeleteStage,
    loading,
    error,
  };
}
